<template>
<div class="site-detail">
    <Error @reload="getData()" v-if="networkError" />
    <div class="intro-page" v-else-if="showPage">
        <v-banner :site="product" />
        <div class="intro-wrapper">
            <div class="intro-brief">
                <div class="intro-name">{{ product.name }}</div>
                <div class="place-rate" v-if="product.rating || product.reviews">
                    <Score :rating="product.rating" v-if="product.rating" />
                    <div class="place-review" v-if="product.reviews">{{ product.reviews }} {{ $t('home.comment') }}</div>
                </div>
            </div>
            <v-detail-content :detailArray="guideArray"
                              :site="product"
                              siteType="show" />
        </div>
        <div class="explore-around">
            <v-explore-list :sites="product.sites" :hotels="product.hotels" :merchants="product.merchants" />
        </div>
    </div>
</div>
</template>

<script>
import { getShowDetail } from '@/fetch/api'
import { GetDistance, formatMinutes } from '@/utils/index'
import Error from '@/components/Error.vue'
import Score from '@/components/Score.vue'
import DetailContent from '@/components/scenic/DetailContent.vue'
import Banner from '@/components/scenic/Banner.vue'
import ExploreList from '@/components/scenic/ExploreList.vue'

export default {
    data () {
        return {
            siteId: '1',
            showPage: false,
            id: '',
            product: {},
            guideArray: [],
            networkError: false
        }
    },
    components: {
        Error,
        Score,
        'v-detail-content': DetailContent,
        'v-banner': Banner,
        'v-explore-list': ExploreList
    },
    created () {
        document.title = this.$t('poi.showTitle')
        this.toast = this.$createToast({
            time: 0,
            txt: this.$t('common.loadingMsg'),
            mask: true
        })
        this.toast.show()
        navigator.geolocation.getCurrentPosition((res) => {
            const longitude = res.coords.longitude
            const latitude = res.coords.latitude
            this.geoData = {
                lon: longitude,
                lat: latitude
            }
            // console.log(longitude, latitude)
            if (longitude) {
                this.getData()
            }
        }, err => {
            this.geoData = {
                lon: 103.82241,
                lat: 1.2651
            }
            this.getData()
        }, { timeout: 5000, enableHighAccuracy: true })
    },
    methods: {
        getData () {
            const params = {
                lon: this.geoData.lon,
                lat: this.geoData.lat
            }
            if (this.$route.query.language === 'zh') {
                params.locale = 'cn'
            } else {
                params.locale = 'en'
            }
            getShowDetail(this.$route.params.id, params).then(res => {
                this.networkError = false
                this.product = res
                this.guideArray = this.processGuide(res)
                this.showPage = true
                this.toast.hide()
            }).catch(err => {
                console.log(err)
                this.toast.hide()
                this.networkError = true
            })
        },
        processGuide (site) {
            let guideArray = []
            if (site.description) {
                guideArray.push({
                    id: 'description',
                    text: this.$t('poi.showDesc'),
                    content: site.description
                })
            }
            if (site.time) {
                guideArray.push({
                    id: 'time',
                    text: this.$t('poi.showTime'),
                    content: site.time
                })
            }
            if (site.contact_phone) {
                guideArray.push({
                    id: 'number',
                    text: this.$t('poi.number'),
                    content: site.contact_phone
                })
            }
            if (site.website) {
                guideArray.push({
                    id: 'website',
                    text: this.$t('poi.website'),
                    content: site.website
                })
            }
            if (site.ticket_strategy) {
                guideArray.push({
                    id: 'ticket',
                    text: this.$t('poi.ticket'),
                    content: site.ticket_strategy
                })
            }
            if (site.traffic_strategy) {
                guideArray.push({
                    id: 'traffic',
                    text: this.$t('poi.traffic'),
                    content: site.traffic_strategy
                })
            }
            if (site.play_strategy) {
                guideArray.push({
                    id: 'recommend',
                    text: this.$t('poi.recommend'),
                    content: site.play_strategy
                })
            }
            if (site.address) {
                guideArray.push({
                    id: 'address',
                    text: this.$t('poi.address'),
                    content: site.address
                })
            }
            return guideArray
        },
    }
}
</script>

<style lang="scss" scoped>
.intro-page {
    margin-bottom: env(safe-area-inset-bottom);
}

.intro-page.from-trip {
    padding-bottom: 160rpx;
}

.intro-page.rws {
    padding-bottom: 140rpx;
}

.intro-page.from-trip.rws {
    padding-bottom: 244rpx;
}
</style>